import React, { useEffect, useState } from "react";
import "../OldSales/Sales.css";
import "./Orders.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import invoiceImg from "../../../assets/images/State-Distributor/viewInvoice.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";

function createData1(
  productCode,
  product,
  uom,
  qty,
  price,
  total,
  discount,
  final
) {
  return {
    productCode,
    product,
    uom,
    qty,
    price,
    total,
    discount,
    final,
  };
}

const rows1 = [
  createData1("004", "Royal Green", "10L", "1200", "₹400", "₹4,80,000"),
];

export const ViewOrders = () => {
  const location = useLocation();
  const { Id } = location.state;
  console.log("Id", Id);
  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const [orderTable, setOrderTable] = useState([]);
  async function LoadOrderDetails(Id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/distributor/order-invoice-details/${Id}/`
      );
      if (response.data.status === "success" || response.status === 200) {
        setOrderDetails(response.data.data);
        setOrderTable(response.data.data.order_items);
        console.log("Order details fetched successfully!");
      }
    } catch (error) {
      toast.error("Order details failed to fetch!");
      console.log("Order details failed to fetch!");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    LoadOrderDetails(Id);
  }, []);
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="salesContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/state-orders" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="addModalTitle">Invoice Details</div>
          </div>
          <div className="invoiceContainer">
            <div className="invoiceContent">
              <div>{orderDetails.invoice_number}</div>
              <div>09/09/2025</div>
            </div>
            <div className="invoiceContent">
              <div>{orderDetails.state_distributor}</div>
              <div>
                <span>{orderDetails.address}</span>
                <br />
                <span>
                  {" "}
                  {orderDetails.city} {orderDetails.state}
                </span>
                <br />
                <span>{orderDetails.phone_number}</span>
                <br />
              </div>
            </div>
            <div className="invoiceImg">
              <img src={invoiceImg} />
            </div>
          </div>
          <div className="invoiceAddressContainer">
            <div className="invoiceAddress">
              <div>Billed To:</div>
              <div
                style={{
                  color: "var(--color-font-primary)",
                  fontWeight: "600",
                }}
              >
                Sri Balaji Paints,
              </div>
              <div>{orderDetails.billed_to}</div>
              {/* <div>Hyderabad, Telangana.</div>
              <div>9632587410</div> */}
            </div>
            <div className="invoiceAddress">
              <div>Payment Type:</div>
              <div
                style={{
                  color: "var(--color-font-primary)",
                  fontWeight: "600",
                }}
              >
                {orderDetails.payment_method}
              </div>
              <div>Due Date:</div>
              <div
                style={{
                  color: "var(--color-font-primary)",
                  fontWeight: "600",
                }}
              >
                {"---"}
              </div>
            </div>
          </div>
          {/* table  */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Product Code</TableCell>
                    <TableCell align="left">Product Name</TableCell>
                    <TableCell align="left">UOM</TableCell>
                    <TableCell align="left">Qty</TableCell>
                    <TableCell align="left">Price/Unit (₹)</TableCell>
                    <TableCell align="left">Total Price</TableCell>
                    <TableCell align="left">GST %</TableCell>
                    <TableCell align="left">CGST + SGST</TableCell>
                    <TableCell align="left">Total After Tax</TableCell>
                    <TableCell align="left">Discount</TableCell>
                    <TableCell align="left">Final Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderTable.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      className="dashboardTableBody"
                    >
                      <TableCell align="left">
                        {row.productCode || "---"}
                      </TableCell>
                      <TableCell align="left">{row.product_name}</TableCell>
                      <TableCell align="left">{row.uom || "---"}</TableCell>
                      <TableCell align="left">{row.qty}</TableCell>

                      <TableCell align="left">{row.price}</TableCell>
                      <TableCell align="left">{row.total}</TableCell>
                      <TableCell align="left">{row.discount}</TableCell>
                      <TableCell align="left">{row.final}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* bank and total table  */}
          <div className="InvoiceContainer">
            <TableContainer component={Paper}>
              <Table 
              // sx={{ minWidth: 650 }} 
              aria-label="simple table">
                <TableBody>
                  {rows1.map((row, index) => (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold", width: "30%" }}>
                          TDS Rate
                        </TableCell>
                        <TableCell align="left">
                          {row.productCode || "---"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Total Payment
                        </TableCell>
                        <TableCell align="left">{row.product_name}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          PhonePe/GPay
                        </TableCell>
                        <TableCell align="left">{row.uom || "---"}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Account No
                        </TableCell>
                        <TableCell align="left">{row.qty}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          IFSC Code
                        </TableCell>
                        <TableCell align="left">{row.price}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Branch
                        </TableCell>
                        <TableCell align="left">{row.total}</TableCell>
                      </TableRow>

                      {/* Optional: Add spacing between items */}
                      <TableRow>
                        <TableCell colSpan={2}>
                          <div style={{ height: 10 }} />
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer component={Paper}>
              <Table 
              // sx={{ minWidth: 650 }}
               aria-label="vertical table">
                <TableBody>
                  {rows1.map((row, index) => (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
                          Total Products (Qty):
                        </TableCell>
                        <TableCell align="left">
                          {row.productCode || "---"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Total Price
                        </TableCell>
                        <TableCell align="left">{row.product_name}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Tax Amount
                        </TableCell>
                        <TableCell align="left">{row.uom || "---"}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Total After Tax
                        </TableCell>
                        <TableCell align="left">{row.qty}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Discount
                        </TableCell>
                        <TableCell align="left">{row.price}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Final Total
                        </TableCell>
                        <TableCell align="left">{row.total}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Payment Status
                        </TableCell>
                        <TableCell align="left">{row.discount}</TableCell>
                      </TableRow>

                    

                      {/* Divider spacing */}
                      <TableRow>
                        <TableCell colSpan={2}>
                          <div style={{ height: 12 }} />
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* qr code  */}
          <div className="qrContainer">
            <div>
              <div>Please make payment within 15 days.</div>
              <div>For any query contact us at:</div>
              <div>
                Mobile : <span style={{ color: "#414652" }}>91 5676789890</span>
              </div>
              <div>
                Email : <span style={{ color: "#414652" }}>abc@gmail.com</span>
              </div>
              <div>
                <div>Scan to pay with QR code</div>
                <img src={invoiceImg} />
              </div>
            </div>
            <div>
              <div>Terms & Conditions</div>
              <div>
                <textarea rows={4}></textarea>
              </div>
            </div>
          </div>
          {/* certified text */}
          <div className="certifiedContainer">
            <div>
              Certified that the particulars given above are true and correct.
            </div>
            <div className="mb-4">For TRADE VIBE GLOBAL</div>
            <div>
              This is a System Generated Invoice. Signature is not required.
            </div>
            <div>Subject to Hyderabad Jurisdiction [E & OE]</div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "20px" }}
            >
              <Link to="/state-orders">
                <button className="addBtnCancel">Cancel</button>
              </Link>

              <button className="addBtnSave">Print Invoice</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
